import { Component, Injector, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ModalComponent } from '../../../../../vass-core/components/modal/modal.component';

@Component({
  selector: 'app-appraisal-modal',
  templateUrl: './appraisal-modal.component.html',
  styleUrls: ['./appraisal-modal.component.scss'],
  standalone: false,
})
export class AppraisalModalComponent implements OnInit {
  public appraisalModalForm: UntypedFormGroup;
  public modalComponent: any;
  public appraisalCost: string;
  public hasAppraisal: boolean;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private _inj: Injector,
  ) {
    this.modalComponent = this._inj.get(ModalComponent);
    this.appraisalCost =
      this.modalComponent &&
      this.modalComponent.data &&
      this.modalComponent.data.appraisalCost
        ? this.modalComponent.data.appraisalCost
        : '0';
    this.hasAppraisal =
      this.modalComponent &&
      this.modalComponent.data &&
      this.modalComponent.data.hasAppraisal
        ? this.modalComponent.data.hasAppraisal
        : '';
  }

  ngOnInit() {
    this.initAppraisalModalForm();
  }

  private initAppraisalModalForm() {
    this.appraisalModalForm = this.formBuilder.group({
      condition: [false],
    });
  }

  public cancel() {
    this.modalComponent.reject();
  }

  public accepted() {
    this.markAsTouchedAllFields();
    this.modalComponent.sendDataFromModal(
      this.hasAppraisal ? { appraisalConditions: true } : this.appraisalModalForm.value,
      { hide: true },
    );
  }

  private markAsTouchedAllFields() {
    for (const field in this.appraisalModalForm.controls) {
      this.appraisalModalForm.controls[field].markAsTouched();
    }
  }
}
